import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserClientListPage = lazy(() => import('../views/list/UserClientListPage'));

export function UserClientListPageLazy() {
	return (
		<PageSuspense>
			<UserClientListPage />
		</PageSuspense>
	);
}
